var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMatches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 33.083192,2.0679061e-4 c 1.057726,0 1.914289,0.85655973939 1.914289,1.91211820939 v 2.7470478 h 5.394616 A 5.4465292,5.4465088 0 0 1 45.84079,10.105881 V 42.551327 A 5.4465292,5.4465088 0 0 1 40.392097,48 H 7.9465296 A 5.4465292,5.4465088 0 0 1 2.5000004,42.551327 V 10.105881 A 5.4465292,5.4465088 0 0 1 7.9465296,4.6593728 H 13.34331 V 1.912325 a 1.9132071,1.9131999 0 0 1 3.826413,0 V 4.6593728 H 31.171067 V 1.912325 c 0,-1.05555847 0.856563,-1.91211820939 1.912125,-1.91211820939 z M 6.3264144,42.551327 c 0,0.897658 0.7246177,1.622273 1.6222783,1.622273 H 40.39426 a 1.6222784,1.6222723 0 0 0 1.622278,-1.622273 V 21.768938 H 6.8714999 A 1.9142885,1.9142813 0 0 1 6.3242514,21.688905 V 42.551327 Z M 7.9486927,8.4836094 A 1.6222784,1.6222723 0 0 0 6.3264144,10.105881 V 18.02257 A 1.9121254,1.9121182 0 0 1 6.8714999,17.9447 H 42.014375 V 10.105881 A 1.6222784,1.6222723 0 0 0 40.392097,8.4836094 h -5.394616 v 2.7189276 a 1.9132071,1.9131999 0 0 1 -3.826414,0 V 8.4836094 H 17.169723 v 2.7189276 a 1.9132071,1.9131999 0 0 1 -3.826413,0 V 8.4836094 H 7.9465296 Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMatches);
export default __webpack_public_path__ + "static/media/menu_matches.cf41f56c15c07037f125f48e8f878aa4.svg";
export { ForwardRef as ReactComponent };